import { render, staticRenderFns } from "./BackGround.vue?vue&type=template&id=4ba073a6&scoped=true"
import script from "./BackGround.vue?vue&type=script&lang=js"
export * from "./BackGround.vue?vue&type=script&lang=js"
import style0 from "./BackGround.vue?vue&type=style&index=0&id=4ba073a6&prod&lang=less&scoped=true"
import style1 from "./BackGround.vue?vue&type=style&index=1&id=4ba073a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba073a6",
  null
  
)

export default component.exports